exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gs-row[data-v-44340088] {\n  max-width: 500px;\n  margin-top: 20px;\n}\n.email-container[data-v-44340088] {\n  vertical-align: top;\n  margin-bottom: 0px;\n}\n.email-input[data-v-44340088] {\n  width: 100%;\n}\n.btn-email[data-v-44340088] {\n  cursor: pointer;\n  margin-top: 6px;\n}\n", ""]);

// exports
